import { createSelector } from '@reduxjs/toolkit'
import { getCollectionOrEmptyObject } from '@opallabs/lambda'
import { Moment, Service } from '../../../../types'
import { getMoments } from '../../getters/entities/moments'
import { getServices } from '../../getters/entities/services'
import { mapAssignmentsToNormalizedAssignments } from '../../utils'
import {
  selectAssignmentContextMap,
  selectAssignments,
  selectStages,
} from './assignments'

export const selectMoments = createSelector([getMoments], (moments) =>
  getCollectionOrEmptyObject<Moment>(moments)
)

export const selectServices = createSelector([getServices], (services) =>
  getCollectionOrEmptyObject<Service>(services)
)

export const selectNormalizedAssignments = createSelector(
  [selectAssignments, selectAssignmentContextMap, selectStages, selectMoments],
  (assignments, assignmentsContextMap, stages, moments) =>
    mapAssignmentsToNormalizedAssignments({
      assignments,
      assignmentsContextMap,
      stages,
      moments,
    })
)
